/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetClassResponse } from './GetClassResponse';
import {
    GetClassResponseFromJSON,
    GetClassResponseFromJSONTyped,
    GetClassResponseToJSON,
    GetClassResponseToJSONTyped,
} from './GetClassResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetClassResponse
 */
export interface PaginatedResultOfGetClassResponse {
    /**
     * 
     * @type {Array<GetClassResponse>}
     * @memberof PaginatedResultOfGetClassResponse
     */
    items?: Array<GetClassResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetClassResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetClassResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetClassResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetClassResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetClassResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetClassResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetClassResponse interface.
 */
export function instanceOfPaginatedResultOfGetClassResponse(value: object): value is PaginatedResultOfGetClassResponse {
    return true;
}

export function PaginatedResultOfGetClassResponseFromJSON(json: any): PaginatedResultOfGetClassResponse {
    return PaginatedResultOfGetClassResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetClassResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetClassResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetClassResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetClassResponseToJSON(json: any): PaginatedResultOfGetClassResponse {
    return PaginatedResultOfGetClassResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetClassResponseToJSONTyped(value?: PaginatedResultOfGetClassResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetClassResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

